/**
 * takes a response from the api (via catch) and throw an object in the following format:
 * {
 *   errors         Array     global errors
 *   field_errors   Array     field specific errors
 *   refresh        Boolean   the response was a critical error (e.g. 500) and didn't contain our expected error body
 * }
 */


export default function(err) {
  if (err.response && err.response.body && Array.isArray(err.response.errors)) {
    // rethrow the errors in a more friendly format
    throw {
      errors: err.response.body.errors || [],
      field_errors: err.response.body.field_errors || [],
      refresh: false
    };
  } else {
    // if we got an error but didn't get a response with error details
    throw {
      errors: [],
      field_errors: [],
      refresh: true
    };
  }
}